// @flow

export const UserRole = {
  TIMER: 'TIMER',
};
